import { PlateData } from '../../components/biology/PlateHeatmap';
import { EchoRunResults } from '../../services/assayRequestApi';

export type EchoResultPlate = EchoRunResults['plates'][number];

export function buildPlateHeatmapData(
  plate: EchoResultPlate,
  assayName: string,
  runCode: string,
): PlateData {
  const wells = plate.wells.map((well) => ({
    position: well.well,
    raw_value: well.raw_rfu ?? null,
    background_subtracted_value: well.background_subtracted_rfu ?? null,
    normalized_value: well.percent_inhibition ?? null,
    role: (well.sample_role || 'empty').toLowerCase(),
    molecule_id: well.molecule_id ?? null,
    compound_name: well.compound_id || null,
    sample_id: well.sample_id || null,
    replicate: well.replicate ?? null,
    concentration: well.final_concentration_um ?? null,
    concentration_unit: 'µM',
    result_status: well.result_status || null,
  }));
  return {
    format: String(plate.format),
    plate_name: plate.barcode,
    protocol_name: `${assayName} · ${runCode}`,
    hit_count: wells.filter((well) => well.role === 'test_compound' &&
      well.normalized_value != null && well.normalized_value >= 50).length,
    wells,
  };
}
